import Image from '@/src/shared/components/Image';

import styles from './AsSeenSection.module.scss';

import { clsx } from 'clsx';

const medias = ['inman', 'forbes', 'dailymail', 'daily-hive', 'techcrunch'];

interface Props {
  className?: string;
}

export default function AsSeenSection({ className }: Props) {
  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.content}>
        <h6 className={styles.title}>As seen in</h6>
        <div className={styles.logos}>
          {medias.map((media) => (
            <div className={styles.logo} key={media}>
              <div
                className={clsx(styles.imgWrapper, {
                  [styles.inman]: media === 'inman',
                  [styles.forbes]: media === 'forbes',
                  [styles.dailymail]: media === 'dailymail',
                  [styles.dailyHive]: media === 'daily-hive',
                  [styles.techcrunch]: media === 'techcrunch',
                })}
              >
                <Image
                  src={`/next-public/images/home/v6/company-logos/${media}.${
                    media === 'daily-hive' ? 'jpg' : 'png'
                  }`}
                  alt={media}
                  fill
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
